import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AggregationRequest } from '../common-interfaces-classes/AggregationRequest';

@Injectable({
  providedIn: 'root'
})
export class InsightsDataService {

  constructor() { }

  private insightsActive: Subject<any> = new Subject();

  setInsightsActive(insightsActive: boolean) {
    this.insightsActive.next({insightsActive})  }

  isInsightsActive()  {
    return this.insightsActive.asObservable();
  }

  private refreshAiData: Subject<any> = new Subject();

  setRefreshAiData(data: any) {
    this.refreshAiData.next({ data });
  }

  fetchRefreshAiData(): Observable<any> {
    return this.refreshAiData.asObservable();
  }

}

